// extracted by mini-css-extract-plugin
module.exports = {"root":"AfterBackImages_root__2ARog","title":"AfterBackImages_title__1KKRF","images":"AfterBackImages_images__1WtvE"};